import { Component, OnInit } from '@angular/core';
import { ProductDashboardService } from './product-dashboard.service';
import { ToastMessageService } from 'src/app/toastr.service';

@Component({
  selector: 'app-product-dashboard',
  templateUrl: './product-dashboard.component.html',
  styleUrls: ['./product-dashboard.component.scss']
})
export class ProductDashboardComponent implements OnInit {
  // roaDropdownOptions: any[];
  roaDropdownOptions: { label: string, value: string }[] = [];
  typeDropdownOptions: any[];
  selectedRoa: string = 'ORAL';
  selectedType: string = 'Live';
  productsData: any;
  selectedRoaData: any[] = [];
  loading: boolean = true;
  proloading: boolean = true;
  notFoundMessage: string;
  email: any;
  selectedProducts: any[] = [];
  displayBulkRemoveDialog: boolean = false;
  emailMessage: string = ''; // Variable to store email data
  isLiveSelected: boolean = false;
  removalComment: any;
  getRemovalProductData: any;
  removeProductRes: any;


  constructor(private ProductDashboardService: ProductDashboardService, private toastService: ToastMessageService,) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.roaDropdownOptions = [{ label: 'ORAL', value: 'ORAL' }];
    this.selectedRoa = 'ORAL';
    this.getProducts();
    this.showRoaData();

    // this.roaDropdownOptions = [
    //   { label: 'Oral', value: 'Oral' },
    //   { label: 'Injectable', value: 'Injectable' }
    // ];
    this.ProductDashboardService.getProductData(this.email).subscribe((response) => {
      if (response.data && response.data.all_roa_list) {
        this.roaDropdownOptions = response.data.all_roa_list.map(roa => {
          return { label: roa, value: roa };
        });
        console.log('ROA List:', response.data.all_roa_list);
        const oralOption = this.roaDropdownOptions.find(option => option.value === 'ORAL');
        if (!oralOption) {
          this.selectedRoa = this.roaDropdownOptions.length > 0 ? this.roaDropdownOptions[0].value : 'Select ROA';
        }
      }
    });

    this.typeDropdownOptions = [
      { label: 'Live', value: 'Live' },
      { label: 'Not in Live', value: 'Not in Live' }
    ]

    this.selectedType = 'Live';
  }

  getRemoveProductsData() {
    console.log("Fetching products to remove:", this.selectedProducts);
    const payload = {
      user_email: this.email,
      remove_data: this.selectedProducts,
      roa: this.selectedRoa,
      differnce: this.selectedType === 'Not in Live' ? 'TRUE' : 'FALSE'
    };
    this.ProductDashboardService.getRemoveProductData(payload).subscribe(
      (response) => {
        console.log("API Response:", response);
        this.getRemovalProductData = response.data;

        const favEmails = this.getRemovalProductData.fav_email || [];
        const bassEmails = this.getRemovalProductData.bass_email || [];

        // Prepare email message for the dialog
        this.emailMessage = '';

        if (favEmails.length > 0) {
          this.emailMessage += `<b>Users who added these products to Favorites:</b><br>${favEmails.join("<br>")}<br><br>`;
        }
        if (bassEmails.length > 0) {
          this.emailMessage += `<b>Users who added these products to their Basket:</b><br>${bassEmails.join("<br>")}`;
        }

        // Show the confirmation dialog
        this.displayBulkRemoveDialog = true;
      },
      (error) => {
        console.error("Error fetching removable products data:", error);
      }
    );
  }


  removeSelectedProducts() {
    console.log("removeSelectedProducts", this.selectedProducts);

    const payload = {
      user_email: this.email,
      remove_data: this.selectedProducts,
      roa: this.selectedRoa,
      comment: this.removalComment,
      differnce: this.selectedType === 'Not in Live' ? 'TRUE' : 'FALSE'
    };
    // console.log("payload", payload);
    this.ProductDashboardService.RemoveProduct(payload).subscribe(
      (response) => {
        this.removeProductRes = response;
        console.log("Response:", this.removeProductRes);

        this.toastService.success('Selected products removed successfully.');
        this.selectedProducts = [];
        this.removalComment = '';
        this.displayBulkRemoveDialog = false;
        this.getProducts();
        this.showRoaData();
      },
      (error) => {
        console.error("Error removing products:", error);

        this.toastService.error('Failed to remove selected products. Please try again.');
      }
    );
  }


  getProducts() {
    this.ProductDashboardService.getProductData(this.email).subscribe((response) => {
      this.productsData = response["data"];
      console.log("resss", this.productsData);
      this.proloading = false;
    });
  }

  showRoaData(): void {
    this.loading = true;
    console.log("this sleected type", this.selectedType)
    this.isLiveSelected = this.selectedType === 'Live';
    const payload = {
      user_email: this.email,
      roa: this.selectedRoa,
      differnce: this.selectedType === 'Not in Live' ? 'TRUE' : 'FALSE'
    };
    console.log("payload", payload)
    this.ProductDashboardService.postProductData(payload)
      .subscribe(
        (response) => {
          this.selectedRoaData = response.data.Data;
          this.loading = false;
          console.log("data", this.selectedRoaData)
        },
        (error) => {
          console.error('Error fetching data:', error);
          this.loading = false;
        }
      );
  }

}
